function randomUuidFromBytes() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function createIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    return randomUuidFromBytes();
  }
  throw new Error('Secure random UUID is unavailable');
}

/**
 * @param {Record<string, string>} [extra]
 * @param {string} [key] - reuse an existing key (e.g. clientMessageId)
 */
export function idempotencyHeaders(extra = {}, key = createIdempotencyKey()) {
  return {
    ...extra,
    'Idempotency-Key': key,
  };
}
